/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function DocsSitePublished({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><circle cx={12.5} cy={3.5} r={3.5} fill="#4DDE98" /><path fill="currentColor" fillRule="evenodd" d="M8.519 1.4H3A2.6 2.6 0 0 0 .4 4v8A2.6 2.6 0 0 0 3 14.6h10a2.6 2.6 0 0 0 2.6-2.6V6.762a4.508 4.508 0 0 1-1.2.818V12a1.4 1.4 0 0 1-1.4 1.4H3A1.4 1.4 0 0 1 1.6 12V4A1.4 1.4 0 0 1 3 2.6h5.09c.086-.425.232-.828.429-1.2Zm-.516 1.93H8A4.67 4.67 0 1 0 12.67 8v-.003a4.493 4.493 0 0 1-3.742-1.76c.074.332.128.7.156 1.094H6.916c.055-.78.214-1.46.43-1.962.134-.314.28-.53.41-.66.13-.126.21-.139.244-.139.023 0 .07.007.142.055a4.508 4.508 0 0 1-.139-1.295ZM6.182 5.044a3.473 3.473 0 0 0-1.587 2.287h1.118c.053-.856.217-1.646.469-2.287Zm.068 5.953A3.472 3.472 0 0 1 4.57 8.53h1.142c.056.929.243 1.78.53 2.45l.008.016Zm1.095-.49c-.216-.504-.376-1.19-.43-1.976h2.17c-.054.787-.214 1.472-.43 1.975-.135.315-.281.531-.412.66-.128.126-.21.14-.243.14s-.115-.014-.243-.14c-.131-.129-.277-.345-.412-.66Zm2.412.473c.288-.669.475-1.52.53-2.449h1.143a3.473 3.473 0 0 1-1.68 2.466l.007-.017Z" clipRule="evenodd" /></svg>;
}
;